//
// <form_key>[=<value>]
//

const analyticsInfo = {
  timestamp: () => performance.now()
};

function click(btn) {
  const key = btn.dataset.analyticsBtn;
  const infoKeys = btn.dataset.analyticsInfo || "";
  const data = new FormData();

  for (const block of infoKeys.split(","))
  {
    const parts = block.split("=");
    let value = null;
    let key = null;

    if (parts.length === 1)
    {
      key = parts[0];
      value = parts[0];
    }
    else
    {
      key = parts[0];
      value = parts[1];
    }

    if (value in analyticsInfo)
    {
      value = analyticsInfo[value](value, btn);
    }

    data.append(key, value);
  }

  data.append("buttonKey", key);
   
  fetch("/api/analytic/log", {
    method: "POST",
    body: data
  })
  .then(res => res.json())
  .then(json => 0);
}

export {
  click
};
